module.exports = __webpack_public_path__ + "img/L_304_361.1ca2b3d5.png";